if (!customElements.get('l-rudd-footer')) {
	class LTARuddFooter extends HTMLElement {
		constructor() {
			super()
			this.handleClick = this.handleClick.bind(this)
		}

		connectedCallback() {
			this.backToTop = this.querySelector('[data-rudd-back-to-top]')
			this.backToTop?.addEventListener('click', this.handleClick)
		}

		disconnectedCallback() {
			this.backToTop?.removeEventListener('click', this.handleClick)
		}

		handleClick() {
			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
			window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
		}
	}

	customElements.define('l-rudd-footer', LTARuddFooter)
}
